import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, withModifiers as _withModifiers, toDisplayString as _toDisplayString, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-edf6b4de"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "ArchiveContracts" }
const _hoisted_2 = { class: "flex items-center justify-between" }
const _hoisted_3 = { class: "grid grid-cols-1 lg:grid-cols-3 gap-3" }
const _hoisted_4 = { class: "flex items-center justify-end mt-3" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-undo mr-2" }, null, -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-search mr-2" }, null, -1))
const _hoisted_7 = { class: "mt-6" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-link" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_attach_document_form = _resolveComponent("attach-document-form")!
  const _component_contract_form = _resolveComponent("contract-form")!
  const _component_page_title = _resolveComponent("page-title")!
  const _component_the_input = _resolveComponent("the-input")!
  const _component_the_select = _resolveComponent("the-select")!
  const _component_the_button = _resolveComponent("the-button")!
  const _component_failed_fetch = _resolveComponent("failed-fetch")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_cheap = _resolveComponent("cheap")!
  const _component_the_table = _resolveComponent("the-table")!
  const _component_table_scroll_wrapper = _resolveComponent("table-scroll-wrapper")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.state.is_attach)
      ? (_openBlock(), _createBlock(_component_attach_document_form, {
          key: 0,
          "contract-id": _ctx.state.contract_id_for_attach,
          loading: _ctx.state.is_attach_loading,
          onCancel: _ctx.cancelAttach,
          onSubmit: _ctx.attachDocument
        }, null, 8, ["contract-id", "loading", "onCancel", "onSubmit"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_1, [
      (_ctx.state.is_add_contract)
        ? (_openBlock(), _createBlock(_component_contract_form, {
            key: 0,
            onCancel: _cache[0] || (_cache[0] = ($event: any) => (_ctx.state.is_add_contract = false)),
            onAdded: _ctx.onContractAdded
          }, null, 8, ["onAdded"]))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _createElementVNode("div", _hoisted_2, [
              _createVNode(_component_page_title, { title: "Архив Договор24" })
            ]),
            _createElementVNode("form", {
              onSubmit: _cache[8] || (_cache[8] = _withModifiers(($event: any) => (_ctx.loadArchiveContracts(1)), ["prevent"])),
              class: "bg-white border px-4 py-2 mt-6"
            }, [
              _createElementVNode("div", _hoisted_3, [
                _createVNode(_component_the_input, {
                  placeholder: "Номер договора",
                  value: _ctx.filters_state.number,
                  "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.filters_state.number) = $event))
                }, null, 8, ["value"]),
                _createVNode(_component_the_input, {
                  placeholder: "БИН",
                  value: _ctx.filters_state.bin,
                  "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.filters_state.bin) = $event))
                }, null, 8, ["value"]),
                _createVNode(_component_the_input, {
                  placeholder: "Название договора",
                  value: _ctx.filters_state.original_name,
                  "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.filters_state.original_name) = $event))
                }, null, 8, ["value"]),
                _createVNode(_component_the_select, {
                  "can-deselect": "",
                  placeholder: "Компания",
                  loading: _ctx.data_state.companies.is_loading,
                  failed: _ctx.data_state.companies.is_failed,
                  "error-text": "При получении списка компаний произошла ошибка",
                  options: _ctx.data_state.companies.list,
                  value: _ctx.filters_state.company_id,
                  "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.filters_state.company_id) = $event)),
                  "search-without-refresh": "",
                  onRefresh: _cache[5] || (_cache[5] = ($event: any) => (_ctx.loadCompanies(_ctx.data_state.companies.pagination.current_page)))
                }, null, 8, ["loading", "failed", "options", "value"]),
                _createVNode(_component_the_select, {
                  "can-deselect": "",
                  placeholder: "Статус",
                  options: _ctx.CONTRACT_STATUSES,
                  value: _ctx.filters_state.status_ids,
                  "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.filters_state.status_ids) = $event)),
                  multiselect: ""
                }, null, 8, ["options", "value"]),
                _createVNode(_component_the_select, {
                  "can-deselect": "",
                  placeholder: "Подразделение",
                  loading: _ctx.data_state.subdivisions.is_loading,
                  failed: _ctx.data_state.subdivisions.is_failed,
                  "error-text": "При получении списка подразделений произошла ошибка",
                  options: _ctx.data_state.subdivisions.list,
                  value: _ctx.filters_state.subdivision_id,
                  "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.filters_state.subdivision_id) = $event)),
                  onRefresh: _ctx.loadSubdivisions
                }, null, 8, ["loading", "failed", "options", "value", "onRefresh"])
              ]),
              _createElementVNode("div", _hoisted_4, [
                _createVNode(_component_the_button, {
                  class: "second text small mr-2",
                  loading: _ctx.state.contracts.is_loading,
                  onClick: _ctx.resetFilters
                }, {
                  default: _withCtx(() => [
                    _hoisted_5,
                    _createTextVNode(" Сброс ")
                  ]),
                  _: 1
                }, 8, ["loading", "onClick"]),
                _createVNode(_component_the_button, {
                  class: "primary text small",
                  loading: _ctx.state.contracts.is_loading,
                  type: "submit"
                }, {
                  default: _withCtx(() => [
                    _hoisted_6,
                    _createTextVNode(" Поиск ")
                  ]),
                  _: 1
                }, 8, ["loading"])
              ])
            ], 32),
            _createElementVNode("div", _hoisted_7, [
              (
                        _ctx.state.contracts.is_failed && !_ctx.state.contracts.failure.error_state.is_cancel
                    )
                ? (_openBlock(), _createBlock(_component_failed_fetch, {
                    key: 0,
                    loading: _ctx.state.contracts.is_loading,
                    text: "При получении списка договоров произошла ошибка",
                    "error-message": _ctx.state.contracts.failure.error_state.message,
                    "error-url": _ctx.state.contracts.failure.error_state.url,
                    "error-status": _ctx.state.contracts.failure.error_state.status,
                    onRefresh: _cache[9] || (_cache[9] = ($event: any) => (_ctx.loadArchiveContracts(_ctx.state.contracts.pagination.current_page)))
                  }, null, 8, ["loading", "error-message", "error-url", "error-status"]))
                : (_openBlock(), _createBlock(_component_table_scroll_wrapper, {
                    key: 1,
                    loading: _ctx.state.contracts.is_loading
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_the_table, {
                        loading: _ctx.state.contracts.is_loading,
                        columns: _ctx.ArchiveContractsColumns,
                        rows: _ctx.state.contracts.list,
                        "with-limit": "",
                        "pagination-limit": _ctx.filters_state.limit,
                        "pagination-total-items": _ctx.state.contracts.pagination.total_items,
                        "pagination-current-page": _ctx.state.contracts.pagination.current_page,
                        "pagination-total-pages": _ctx.state.contracts.pagination.total_pages,
                        onChangePage: _ctx.loadArchiveContracts,
                        onChangeLimit: _ctx.onLimitChange
                      }, {
                        td: _withCtx(({ column, row }) => [
                          (column.key === 'number')
                            ? (_openBlock(), _createBlock(_component_router_link, {
                                key: 0,
                                to: `/contracts/${row.id}`,
                                class: "ArchiveContracts__link"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(row.number), 1)
                                ]),
                                _: 2
                              }, 1032, ["to"]))
                            : (column.key === 'date')
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                  _createTextVNode(_toDisplayString(_ctx.formatDateFromBackend(row.date)), 1)
                                ], 64))
                              : (column.key === 'expiration_date')
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                    _createTextVNode(_toDisplayString(_ctx.formatDateFromBackend(row.expiration_date)), 1)
                                  ], 64))
                                : (column.key === 'createdAt')
                                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                                      _createTextVNode(_toDisplayString(_ctx.formatDateWithTimeFromBackend(row.createdAt)), 1)
                                    ], 64))
                                  : (column.key === 'original_name')
                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
                                        _createTextVNode(_toDisplayString(_ctx.cutName(row[column.key])), 1)
                                      ], 64))
                                    : (column.key === 'custom_company_name')
                                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 5 }, [
                                          _createTextVNode(_toDisplayString(_ctx.cutName(row[column.key])), 1)
                                        ], 64))
                                      : (column.key === 'documents')
                                        ? (_openBlock(), _createElementBlock("i", {
                                            key: 6,
                                            class: _normalizeClass(_ctx.getCheckOrTimesIcon(Boolean(row.path)))
                                          }, null, 2))
                                        : (column.key === 'prolongation')
                                          ? (_openBlock(), _createElementBlock("i", {
                                              key: 7,
                                              class: _normalizeClass(_ctx.getCheckOrTimesIcon(Boolean(row.is_auto_renewal)))
                                            }, null, 2))
                                          : (column.key === 'status')
                                            ? (_openBlock(), _createBlock(_component_cheap, {
                                                key: 8,
                                                class: _normalizeClass(["small", {
                                        red: row.status_id === '2',
                                    }])
                                              }, {
                                                default: _withCtx(() => [
                                                  _createTextVNode(_toDisplayString(row.status), 1)
                                                ]),
                                                _: 2
                                              }, 1032, ["class"]))
                                            : (_openBlock(), _createElementBlock(_Fragment, { key: 9 }, [
                                                _createTextVNode(_toDisplayString(row[column.key]), 1)
                                              ], 64))
                        ]),
                        actions: _withCtx(({ row }) => [
                          _createVNode(_component_the_button, {
                            hint: "Прикрепить документ",
                            class: "primary extra-small mr-3",
                            onClick: ($event: any) => (_ctx.startAttach(row.id))
                          }, {
                            default: _withCtx(() => [
                              _hoisted_8
                            ]),
                            _: 2
                          }, 1032, ["onClick"])
                        ]),
                        _: 1
                      }, 8, ["loading", "columns", "rows", "pagination-limit", "pagination-total-items", "pagination-current-page", "pagination-total-pages", "onChangePage", "onChangeLimit"])
                    ]),
                    _: 1
                  }, 8, ["loading"]))
            ])
          ], 64))
    ])
  ], 64))
}